import { toast } from "react-toastify";
import {
  DEFAULT_LOCALE,
  getLocaleFromPath,
  withLocale,
} from "../../config/locales";

export function setCookie(cname, cvalue) {
  const exdays = 30;
  var secure = "";
  if (window.location.protocol === "https") {
    secure = "secure;";
  }
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + secure + expires + "; path=/";
}

export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

export function deleteCookie(cname) {
  document.cookie =
    cname + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}

export function deleteAllCookies() {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  }
}

export const getBrowserLanguage = () => {
  const browserLanguage = navigator.language || navigator.userLanguage;
  return browserLanguage?.split("-")[0];
};

export const updateElementClassById = (id, className, action) => {
  const el = document.getElementById(id);
  if (el) {
    el.classList[action](className);
  }
};

export function removeWhiteSpaceFromString(text) {
  return text?.replace(/\s/g, "");
}

export const emailValidation = (value) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(value).toLowerCase());
};

export const checkFormErrors = (formErrors) => {
  return Object.values(formErrors).every((item) => item === true);
};

export function getInputSpeechId(q) {
  return "question_input_" + q?.id + "_" + q?.name;
}

export const countValidTranscripts = (data) => {
  let count = 0;
  data.forEach((category) => {
    category.questions.forEach((question) => {
      if (question.transcript && question.transcript.trim() !== "") {
        count++;
      }
    });
  });
  return count;
};

export const countTotalQuestions = (data) => {
  let total = 0;
  data.forEach((category) => {
    total += category.questions.length;
  });
  return total;
};

export const checkIfChapterHaveLessThanOneQuestion = (data) => {
  data.forEach((element) => {
    if (element?.questions?.length === 0) {
      return true;
    }
  });
  return false;
};

export const generateRandomString = (length = 8) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const showHideModal = (id) => {
  const modal = document.getElementById(id);
  if (modal?.style?.display === "none") {
    modal.style.display = "block";
  } else {
    modal.style.display = "none";
  }
};

export const showToast = ({
  type,
  message,
  position = "bottom-left",
  autoClose = 4000,
}) => {
  toast[type](message, {
    position,
    autoClose,
  });
};

export const getDateInTimeZone = (
  date = new Date(),
  timeZone = "Europe/London"
) => {
  // Format the date with the specified timezone
  let options = {
    timeZone: timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  // Create a formatter
  let formatter = new Intl.DateTimeFormat("en-US", options);
  let parts = formatter.formatToParts(date);

  // Assemble the formatted date
  let formattedDate = `${parts.find((part) => part.type === "year").value}-${
    parts.find((part) => part.type === "month").value
  }-${parts.find((part) => part.type === "day").value} ${
    parts.find((part) => part.type === "hour").value
  }:${parts.find((part) => part.type === "minute").value}:${
    parts.find((part) => part.type === "second").value
  }`;

  return formattedDate;
};

async function deriveKey() {
  const enc = new TextEncoder();
  const keyMaterial = await window.crypto.subtle.importKey(
    "raw",
    enc.encode(process.env.REACT_AES_KEY),
    "PBKDF2",
    false,
    ["deriveBits", "deriveKey"]
  );

  return await window.crypto.subtle.deriveKey(
    {
      name: "PBKDF2",
      salt: enc.encode("salt"),
      iterations: 100000,
      hash: "SHA-256",
    },
    keyMaterial,
    {
      name: "AES-GCM",
      length: 256,
    },
    true,
    ["encrypt", "decrypt"]
  );
}

export async function encryptString(string) {
  const key = await deriveKey();
  const encoded = new TextEncoder().encode(string);
  const iv = window.crypto.getRandomValues(new Uint8Array(12)); // Initialization vector
  const encrypted = await window.crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: iv,
    },
    key,
    encoded
  );
  return {
    iv: Array.from(iv),
    encrypted: Array.from(new Uint8Array(encrypted)),
  };
}

export async function decryptString(encryptedData) {
  try {
    const key = await deriveKey();
    const iv = new Uint8Array(encryptedData.iv);
    const encrypted = new Uint8Array(encryptedData.encrypted);
    const decrypted = await window.crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: iv,
      },
      key,
      encrypted.buffer
    );
    return new TextDecoder().decode(decrypted);
  } catch (error) {
    return "{}";
  }
}
/**
 * Safely convert internal style tags (<i>, <b>, <font size>, <color>, <footnote>) to HTML.
 * All content is escaped first; only whitelisted tags are restored as safe inline styles.
 * Arbitrary HTML cannot pass through because values are validated before placeholdering.
 */
/**
 * Decode HTML entities (e.g. &#039; &amp; &quot;) into their real characters.
 * Manuscript text extracted by the backend can arrive HTML-encoded; decoding it
 * here prevents the escape step below from double-encoding it (which would
 * surface raw entities like &#039; in the rendered preview).
 * A <textarea> is an RCDATA element, so character references are decoded while
 * any literal style tags (<i>, <font ...>) are preserved as text for the
 * placeholder/escape pipeline that follows.
 */
export const decodeHtmlEntities = (text) => {
  if (!text) return "";
  if (typeof document === "undefined") return text;
  const ta = document.createElement("textarea");
  ta.innerHTML = text;
  return ta.value;
};

export const sanitizeStyleTags = (text) => {
  if (!text) return "";

  let cleaned = decodeHtmlEntities(text).replace(/\[BLANK\]/g, "");

  // Replace recognised style tags with placeholders BEFORE HTML-escaping.
  // Placeholders contain no < > " characters so they survive the escape step intact.
  cleaned = cleaned
    // <font size="12"> — whitelist: numeric, 6–72pt range
    .replace(/<font\s+size="([0-9.]+)">/gi, (_, size) => {
      const s = parseFloat(size);
      return !isNaN(s) && s >= 6 && s <= 72 ? `{{FS_${s}}}` : "";
    })
    // <color value="..."> — accept hex (#rrggbb) or rgb(r,g,b); normalize both to hex
    .replace(/<color\s+value="([^"]+)">/gi, (_, raw) => {
      let hex = null;
      if (/^#[a-fA-F0-9]{3,6}$/.test(raw)) {
        hex = raw.slice(1);
      } else {
        const m = raw.match(/rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)/i);
        if (m) {
          hex = [m[1], m[2], m[3]]
            .map((n) => parseInt(n, 10).toString(16).padStart(2, "0"))
            .join("");
        }
      }
      return hex ? `{{CL_${hex}}}` : ""; // unrecognised format → strip silently
    })
    .replace(/<\/color>/gi, "{{/CL}}")
    // Strip font-name tags (frontend shows default font; DOCX export handles these)
    .replace(/<font\s+name="[^"]*">/gi, "")
    // Remaining </font> close the size tags placeholdered above
    .replace(/<\/font>/gi, "{{/FS}}");

  // Escape everything — placeholders are untouched
  let safe = cleaned
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

  // Restore bold / italic
  safe = safe.replace(/&lt;(\/?)(i|b)&gt;/gi, "<$1$2>");

  // Restore font-size spans (value already range-checked above)
  safe = safe
    .replace(/\{\{FS_([0-9.]+)\}\}/g, '<span style="font-size:$1pt">')
    .replace(/\{\{\/FS\}\}/g, "</span>");

  // Restore color spans (hex value already validated above)
  safe = safe
    .replace(/\{\{CL_([a-fA-F0-9]{3,6})\}\}/g, '<span style="color:#$1">')
    .replace(/\{\{\/CL\}\}/g, "</span>");

  // Convert <footnote>...</footnote> to superscript
  safe = safe.replace(
    /&lt;footnote&gt;(.*?)&lt;\/footnote&gt;/gs,
    '<sup style="font-size:0.75em;color:#666">[$1]</sup>'
  );

  return safe;
};

/**
 * Strip all internal style tags from text, returning plain text.
 * Useful for textareas and other contexts where HTML can't render.
 */
export const stripStyleTags = (text) => {
  if (!text) return "";
  return decodeHtmlEntities(text)
    .replace(/\[BLANK\]/g, "")
    .replace(/<\/?(?:i|b)>/gi, "")
    .replace(/<font\s+(?:name|size)="[^"]*">/gi, "")
    .replace(/<\/font>/gi, "")
    .replace(/<color\s+value="[^"]*">/gi, "")
    .replace(/<\/color>/gi, "")
    .replace(/<footnote>(.*?)<\/footnote>/gs, "[$1]");
};

export const buildLocalizedPath = (path) => {
  const locale = getLocaleFromPath(window.location.pathname) ?? DEFAULT_LOCALE;
  return withLocale(locale, path);
};
